export const GENERATE_TEMPORAL_PASSWORD_MOCK = {
  success: [{}],
  failures: [{
    path: 'path',
    statusCode: 0,
    messageError: 'El servicio ha respondido con un error.'
  }]
};
